import React from 'react';
// Constants
import {
  MANYVIDS_URL,
  ONLYFANS_URL,
} from '../../utils/Constants';
import {
  CONTACT_PAGE_URL,
} from '../../utils/Routes';
// Images
import OnlineImage from '../../assets/images/noBackground/mistress-sammi-smith-trans-dominatrix-no-background-full-body-small.png';
import FilmingImage from '../../assets/images/noBackground/mistress-sammi-smith-trans-dominatrix-no-background-with-sub-on-cross.png';
import LastImage from '../../assets/images/noBackground/mistress-sammi-smith-trans-dominatrix-no-background-ass-facing-camera-small.png';
// Components
import InformationSection from '../general/InformationSection';
import CallToActionOne from '../cta/CallToActionOne';

function ClipsPageMainContainer() {
  return (
    <main role='main' className='grid w-full h-full overflow-hidden -mt-6'>
      {/* Text section */}
      <section className='grid gap-2 text-center mx-auto lg:max-w-[50%] py-8 px-8 sm:px-16 md:px-24'>
        <h3 className='text-4xl md:text-5xl font-titleFont'>
          Clips, Videos, and More Available!
        </h3>
        <p>
          You can find exclusive, dirty, and sexy content featuring TS Mistress
          Sammi Smith. Whether you're looking for intimate solo clips, custom
          content, or full-length videos, I have something just for you. Browse
          my stores and explore your desires!
        </p>
      </section>

      {/* info grids */}
      <section className='grid gap-8'>
        {/* OnlyFans Section */}
        <InformationSection
          sectionImage={OnlineImage}
          title={'OnlyFans'}
          orientation={true}
        >
          <div className='grid lg:text-lg'>
            <p>
              Want access to my exclusive and most intimate content? Subscribe
              to my OnlyFans and explore a world of custom content tailored just
              for you. I regularly update with fresh, high-quality content you
              won’t find anywhere else.
            </p>
            <p>
              If you enjoy my work and want to show your appreciation, message
              me for my wishlist – I love being spoiled!
            </p>
            <div className='mt-4 lg:mt-1'>
              <a
                href={ONLYFANS_URL}
                className='blinking-button active:scale-90'
                target='_blank'
                rel='noopener noreferrer'
              >
                Explore My OnlyFans
              </a>
            </div>
          </div>
        </InformationSection>

        {/* ManyVids Section */}
        <InformationSection
          sectionImage={FilmingImage}
          title={'ManyVids'}
          orientation={false}
        >
          <div className='grid lg:text-lg'>
            <p>
              Looking for longer, more immersive videos? My ManyVids store
              offers an expanded library of content, perfect for those who want
              more. Each video is crafted to bring your fantasies to life with
              high-quality production.
            </p>
            <p>
              I also post select content on FetLife, so feel free to follow me
              there for sneak peeks and updates on new releases!
            </p>
            <div className='mt-4 lg:mt-1'>
              <a
                href={MANYVIDS_URL}
                className='blinking-button active:scale-90'
                target='_blank'
                rel='noopener noreferrer'
              >
                Browse My ManyVids
              </a>
            </div>
          </div>
        </InformationSection>

        {/* Custom Fetish Content Section */}
        <InformationSection
          sectionImage={LastImage}
          title={'Custom Fetish Content'}
          orientation={true}
        >
          <div className='grid lg:text-lg'>
            <p>
              Indulge in the ultimate personalized experience with Mistress
              Sammi. I offer custom fetish videos, clips, voice messages,
              text interactions, tailored to fulfill your deepest
              desires. Every request is carefully crafted to ensure your
              satisfaction and submission.
            </p>
            <p>
              Whether you crave a sensual tease, strict discipline,
              humiliation, JOI, or any fetish fantasy, I create content that
              is uniquely yours. Message me with your request and let’s make
              your fantasy a reality.
            </p>
            <p>
              Show your devotion by spoiling me—ask for my wishlist if you want
              to impress your Goddess.
            </p>
            <div className='mt-4 lg:mt-1'>
              <a
                href={CONTACT_PAGE_URL} // Replace with the correct link
                className='blinking-button active:scale-90'
                target='_blank'
                rel='noopener noreferrer'
              >
                Request Your Custom Content
              </a>
            </div>
          </div>
        </InformationSection>
      </section>

      {/* Call to Action */}
      <div className='pt-6'>
        <CallToActionOne />
      </div>
    </main>
  );
}

export default ClipsPageMainContainer;
